import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const bulkUpdateTestStepsInSuite = async ({ testSuiteId, testStepId, testStepIds, nonMatchedTestCases }) => {
  const user = getUserDetails();

  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateTestStepsInBulk&companyId=${user.companyid}`,
    {
      testSuiteId,
      testStepId,
      testStepIds,
      nonMatchedTestCases,
    },
  );

  if (response.data?.status === "error" || response.data?.message === "Failed") {
    throw new Error(response.data.message || "Failed to update test steps");
  }

  return response.data;
};

const useBulkUpdateSimilarStepsMutation = (options = {}) => {
  return useMutation({
    mutationFn: bulkUpdateTestStepsInSuite,
    ...options,
  });
};

export default useBulkUpdateSimilarStepsMutation;
